import {
  reportError,
  setLoading,
  setLoadingText,
} from '.';

import {
  loopbackGet,
  loopbackPost,
} from '../../loopback';
import ApiClient from '../../loopback/apiClient';
import { ExtendedEnrollment } from '../../views/EvaluationDialog';
import { AppThunk, Trial } from '../types';
import { showErrorNotification } from './appActions';

// create individual certificates
// from trial details actions
export const recreateCertificate = (enrollment: ExtendedEnrollment) => () => {
  const { id, surveySubmissionMeta, thirdPartyEnrollment } = enrollment;
  if (surveySubmissionMeta) {
    return loopbackPost(`enrollments/${id}/createCertificate`);
  }
  return thirdPartyEnrollment
    ? loopbackGet(`enrollments/${enrollment.id}/createOrUpdateMultiblockCertificate`)
    : loopbackGet(`enrollments/${enrollment.id}/createOrUpdateCertificate?locale=de&overwriteApprovedCertificates=true`);
};

// create all certificates based on Trial
// from trial actions
export const createCertificates = (trial: Trial): AppThunk => async (dispatch, getState) => {
  dispatch(setLoading(true));
  dispatch(setLoadingText(getState().intl.messages['trialmanagement.fetchingEnrollments']));
  const otherFilter = { include: ['quipUser', { trial: 'thirdPartyTrial' }] };
  const enrollments: any = await ApiClient.getEnrollments(trial.id, { status: 'approved' }, otherFilter);

  if (!enrollments || enrollments.length === 0) {
    Promise.reject(new Error('no enrollments to process'));
  }

  let completedCerts = 0;
  const updateCompletedCerts = () => {
    completedCerts += 1;
    dispatch(setLoadingText(`${getState().intl.messages['trialmanagement.certificateProcess']}(${completedCerts}/${enrollments.length})`));
  };

  const { version = 1 } = trial;
  let certificationCreationMethod: string;
  if (version > 1) {
    certificationCreationMethod = 'createCertificate';
  } else {
    certificationCreationMethod = enrollments[0].trial.thirdPartyTrial ? 'createOrUpdateMultiblockCertificate' : 'createOrUpdateCertificate';
    certificationCreationMethod += '?locale=de';
  }
  const promises = enrollments.map((enrollment: any) => {
    if (version > 1) {
      return loopbackPost(`enrollments/${enrollment.id}/createCertificate`, undefined).then(updateCompletedCerts);
    }
    return loopbackGet(`enrollments/${enrollment.id}/${certificationCreationMethod}`).then(updateCompletedCerts);
  });
  return Promise.allSettled(promises).then((results: any) => {
    dispatch(setLoadingText(getState().intl.messages['trialmanagement.certificateProcessCompleted']));
    setTimeout(() => {
      dispatch(setLoading(false));
    }, 1000);
    const rejectionMessages = results.filter((r: any) => r.status === 'rejected').map((r: any) => r.reason.message).join(', ');
    if (rejectionMessages) {
      dispatch(showErrorNotification(rejectionMessages));
    }
  }).catch((error: any) => dispatch(showErrorNotification(`Error during creating list of participants for trial: ${trial.id}: ${error.message}`)));
};

// todo : move to apiClient
export const unapproveCertificate = (certificate: any, reason: any) => () => loopbackPost(`Certificates/${certificate.id}/unapprove?reason=${reason}`);
